import { getAssetsDomain } from '../assets/assetsDomain.js';

function useBrandImage(name, scale, format) {
    if (scale === void 0) { scale = '1'; }
    if (format === void 0) { format = '.webp'; }
    var domain = getAssetsDomain();
    var suffix = (function () {
        switch (scale) {
            case '2': return '@2x';
            case '3': return '@3x';
            case '0.675': return '@.675x';
            default: return '';
        }
    })();
    return "".concat(domain, "/app-assets/brand-illustrations/").concat(name).concat(suffix).concat(format);
}

export { useBrandImage };
